import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import mainLogo from '../../components/assets/images/bdih_logo.png';

const parentVariants = {
  initial: {},
  animate: {
    transition: {
      staggerChildren: 0.18,
    },
  },
};

const childVariants = {
  initial: { opacity: 0, scale: 0.7, y: 20 },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 120, damping: 10 },
  },
};

const SplashScreen = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/landing');
    }, 3000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <motion.div
      className="flex min-h-screen items-center justify-center bg-gradient-to-br from-gray-900 via-gray-800 to-black px-4 py-6 md:py-8"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div
        className="relative flex flex-col items-center text-center"
        variants={parentVariants}
        initial="initial"
        animate="animate"
      >
        {/* <motion.img
          src={mainLogo}
          alt="411 Group Logo"
          className="mb-4 sm:mb-6 md:mb-8 h-16 w-16 sm:h-24 sm:w-24 md:h-32 md:w-32 object-contain"
          variants={childVariants}
        /> */}

        <motion.h1
          className="text-3xl font-black leading-tight tracking-tighter text-white sm:text-4xl md:text-5xl lg:text-6xl xl:text-7xl 2xl:text-8xl"
          variants={childVariants}
        >
          411 • Group
        </motion.h1>

        <motion.p
          className="mt-2 max-w-xs text-xs font-light tracking-wider text-gray-400 sm:mt-3 sm:max-w-sm sm:text-sm md:mt-4 md:max-w-md md:text-base lg:max-w-lg lg:text-lg xl:text-xl"
          variants={childVariants}
        >
          INNOVATING • CONNECTING • EVOLVING
        </motion.p>

        <motion.div
          className="absolute -bottom-4 left-1/2 flex -translate-x-1/2 transform gap-1 sm:-bottom-6 sm:gap-1.5 md:-bottom-8 md:gap-2"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8 }}
        >
          {[0, 1, 2].map(dot => (
            <motion.div
              key={dot}
              className="h-1 w-1 rounded-full bg-gray-400 sm:h-1.5 sm:w-1.5 md:h-2 md:w-2"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.5, 1, 0.5],
              }}
              transition={{
                duration: 1,
                repeat: Infinity,
                delay: dot * 0.2,
              }}
            />
          ))}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default SplashScreen;
